import React from 'react'
import { useDispatch } from 'react-redux'
import { Button, AppBar, Toolbar, IconButton, Typography, TextField } from '@material-ui/core'
import { store, success as changeSuccess } from '../../../../store/actions/menor.gestao.action'
import { MdKeyboardBackspace } from 'react-icons/md'
import { FaSave } from 'react-icons/fa'
import MaskedInput from 'react-text-mask' 
import { changeScreenC } from '../../../../store/actions/navigation.action'

const TextMaskCustom = (props) => {
    const { inputRef, ...other } = props;
    let mask = [];

    if (props.name === 'qtd') {
        mask = [/[0-9]/, /\d/, /\d/]
    }

    return (
        <MaskedInput
            {...other}
            ref={ref => {
                inputRef(ref ? ref.inputElement : null)
            }}
            mask={mask}
            guide={false}
        />
    )
}

export default function MenorGestaoCreate(props) {
    const dispatch = useDispatch()
    const campaign_id = (props.campaign_id) ? props.campaign_id : null
    const view = (props.view) ? props.view : null
    const [qtd, setQtd] = React.useState(1)
    const [type, setType] = React.useState('menor')

    React.useEffect(() => {
        return () => {
            dispatch(changeSuccess(false))
        }
        //eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const _save = () => {
        dispatch(store({
            'qtd' : qtd,
            'campaign_id' : campaign_id,
            'type' : type
        },view))
    }

    return (
        <>
            <AppBar position="fixed">
                <Toolbar>
                    <IconButton onClick={() => dispatch(changeScreenC({ open: false }))} edge="start" color="inherit">
                        <MdKeyboardBackspace />
                    </IconButton>
                    <Typography variant="h6">Nova Cota</Typography>

                    <Button 
                        variant="contained" 
                        size="small"
                        onClick={() => _save()}
                        color="inherit" 
                        className="ms-auto btn-app-bar"
                        startIcon={<FaSave />}
                    >
                        Salvar
                    </Button>
                </Toolbar>
            </AppBar>

            <div className="mt-5 pt-1 bg-clear min-vh-100">
                <div className="card card-body mt-2 bs-bg">
                    <div className="row mb-3">
                        <div className="col-3">
                            <Button 
                                fullWidth 
                                className={"bs-bg-invert bs-color-b "+ (type === 'menor' && 'btn-checked')}
                                variant="contained" 
                                color="primary" 
                                size="small"
                                onClick={() => setType('menor')}
                            >
                                MENOR
                            </Button>
                        </div>
    
                        <div className="col-3">
                            <Button 
                                fullWidth 
                                className={"bs-bg-invert bs-color-b "+ (type === 'maior' && 'btn-checked')}
                                variant="contained" 
                                color="primary" 
                                size="small"
                                onClick={() => setType('maior')}
                            >
                                MAIOR
                            </Button>
                        </div>
                    </div>

                    <div className="mb-3">
                        <label className="label-custom d-block bs-color-b">Quantidade de Cotas</label>
                        <TextField
                            name="qtd"
                            type="tel"
                            InputProps={{
                                inputComponent: TextMaskCustom,
                                value: qtd,
                                placeholder: '1',
                                onChange: e => setQtd(e.target.value ? parseInt(e.target.value) : e.target.value)
                            }}
                        />
                    </div>

                    <div className="mb-3">
                        <div className="alert alert-success mt-3" role="alert">
                            <strong>Menor:</strong> Escolha a quantidade e o sistema escolhe as menores cotas disponiveis.
                        </div>
                        <div className="alert alert-warning mt-3" role="alert">
                            <strong>Maior:</strong> Escolha a quantidade e o sistema escolhe as maiores cotas disponiveis.
                        </div>
                    </div> 
                </div>
            </div>
        </>
    )
}